module.exports = __webpack_public_path__ + "img/eng-graphics-and-design.7866eb5e.svg";